import api from '../client';

export const ProjectsService = {
  getProjects: () => api.get('/tasks/projects'),
  getProjectById: (id) => api.get(`/tasks/projects/${id}`),
  createProject: (data) => api.post('/tasks/projects', data),
  updateProject: (id, data) => api.patch(`/tasks/projects/${id}`, data),
  deleteProject: (id) => api.delete(`/tasks/projects/${id}`),
  addComment: (id, data) => api.post(`/tasks/projects/${id}/comments`, data),
  addCommentWithFile: (id, formData) => api.post(`/tasks/projects/${id}/comments`, formData),
};
